<div>
    <swiper>
        <ng-template swiperSlide>
            <app-lucky-slider1 class="slider"></app-lucky-slider1>
        </ng-template>
        <ng-template swiperSlide>
            <app-lucky-slider2 class="slider"></app-lucky-slider2>
        </ng-template>
        <ng-template swiperSlide>
            <app-lucky-slider3 class="slider"></app-lucky-slider3>
        </ng-template>
    </swiper>
</div>